import { z } from 'zod'

/**
 * 사용자 스키마 정의
 * - 폼 검증 규칙 설정
 * - TypeScript 타입 추론을 위한 Zod 스키마
 * password와 confirmPassword 필드는 일치 해야한다.
 */
export const userSchema = z
	.object({
		id: z.number().optional(),
		username: z
			.string()
			.min(3, '아이디는 최소 3자 이상이어야 합니다.')
			.max(20, '아이디는 최대 20자 이하이어야 합니다.'),
		password: z.string().min(6, '비밀번호는 최소 6자 이상이어야 합니다.'),
		name: z
			.string()
			.min(2, '이름을 입력해주세요.')
			.max(20, '이름은 최대 20자 이하이어야 합니다.'),
		phone: z.string().length(13, '전화번호는 13자리로 입력해주세요.'),
		email: z
			.string()
			.min(1, '이메일을 입력해주세요.')
			.regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, '유효한 이메일 주소를 입력해주세요.'),
		passwordConfirm: z
			.string()
			.min(6, '비밀번호 확인은 최소 6자 이상이어야 합니다.'),
	})
	.refine((data) => data.password === data.passwordConfirm, {
		message: "Passwords don't match",
		path: ['passwordConfirm'], // This specifies where the error message should be displayed
	})
